import { createSelector } from 'reselect'

import * as Util from './mining.utils'

export const getMiningState = (state) => state.mars.mining
export const getAllMiningScreens = (state) => state.storyLine.miningScreens

export const getOwnQuestions = createSelector(
  [getMiningState],
  (miningState) => miningState.ownQuestions
)

export const getDisputedQuestions = createSelector([getMiningState], (miningState) =>
  Util.mergeDuplicates(miningState.disputedQuestions)
)

export const getDebatedQuestions = createSelector([getMiningState], (miningState) =>
  Util.mergeDuplicates(miningState.debatedQuestions)
)

export const getTotalLikes = createSelector([getOwnQuestions], (ownQuestions) =>
  ownQuestions.reduce((acc, curr) => acc + curr.likes, 0)
)

export const getCurrentMiningScreen = createSelector(
  [getMiningState],
  (mining) => mining.currentScreen
)
export const getAvailableSignal = createSelector([getMiningState], (mining) => mining.signal)
export const getSignalScreen = createSelector(
  [getAllMiningScreens, getMiningState],
  (miningScreens, mining) => miningScreens[mining.signal]
)

export const getPrevScreen = createSelector([getMiningState], (mining) => mining.prevScreen)

export const getCountDisputes = createSelector([getMiningState], (mining) => mining.countDisputes)
